module.exports = __webpack_public_path__ + "img/millfields_rd_b8.5791771d.jpg";